import apiService from '../utils/apiService';

import {
  ADD_TRAVEL_ORDER,
  ADD_TRAVEL_ORDER_ERROR,
  ADD_TRAVEL_ORDER_START,
  CLEAR_ERROR_TRAVEL_ORDER,
  DELETE_TRAVEL_ORDER,
  DELETE_TRAVEL_ORDER_ERROR,
  DELETE_TRAVEL_ORDER_START,
  GET_TRAVEL_ORDER,
  GET_TRAVEL_ORDER_ERROR,
  GET_TRAVEL_ORDER_LIST,
  GET_TRAVEL_ORDER_LIST_ERROR,
  GET_TRAVEL_ORDER_LIST_PAGEABLE,
  GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR,
  GET_TRAVEL_ORDER_LIST_PAGEABLE_START,
  GET_TRAVEL_ORDER_LIST_START,
  GET_TRAVEL_ORDER_START,
  UPDATE_TRAVEL_ORDER,
  UPDATE_TRAVEL_ORDER_ERROR,
  UPDATE_TRAVEL_ORDER_START
} from './types';

import {
  travelOrderAddPath,
  travelOrderUpdatePath,
  travelOrderFindAllPageablePath,
  travelOrderFindByIdPath,
  travelOrderDeletePath,
  travelOrderFindAllPath,
  travelOrderDownloadPath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ModalForAddOrUpdateTravelOrder } from '../enums/TravelOrderEnums';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_TRAVEL_ORDER,
  };
};

const addTravelOrderStart = () => {
  return {
    type: ADD_TRAVEL_ORDER_START,
  };
};
const addTravelOrderSuccessfully = (data) => {
  return {
    type: ADD_TRAVEL_ORDER,
    payload: data,
  };
};
const addTravelOrderUnsuccessfully = (err) => {
  return {
    type: ADD_TRAVEL_ORDER_ERROR,
    payload: err,
  };
};

const updateTravelOrderStart = () => {
  return {
    type: UPDATE_TRAVEL_ORDER_START,

  };
};
const updateTravelOrderSuccessfully = (data) => {
  return {
    type: UPDATE_TRAVEL_ORDER,
    payload: data,
  };
};
const updateTravelOrderUnsuccessfully = (err) => {
  return {
    type: UPDATE_TRAVEL_ORDER_ERROR,
    payload: err,
  };
};

const getTravelOrderStart = () => {
  return {
    type: GET_TRAVEL_ORDER_START,
  };
};
const getTravelOrderSuccessfully = (data) => {
  return {
    type: GET_TRAVEL_ORDER,
    payload: data,
  };
};
const getTravelOrderUnsuccessfully = (err) => {
  return {
    type: GET_TRAVEL_ORDER_ERROR,
    payload: err,
  };
};

const getTravelOrderPageableListStart = () => {
  return {
    type: GET_TRAVEL_ORDER_LIST_PAGEABLE_START,
  };
};

const getTravelOrderPageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_TRAVEL_ORDER_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getTravelOrderListPageableUnsuccessfully = (err) => {
  return {
    type: GET_TRAVEL_ORDER_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const deleteTravelOrderStart = () => {
  return {
    type: DELETE_TRAVEL_ORDER_START,
  };
};
const deleteTravelOrderSuccessfully = (id) => {
  return {
    type: DELETE_TRAVEL_ORDER,
    payload: id,
  };
};
const deleteTravelOrderUnsuccessfully = (err) => {
  return {
    type: DELETE_TRAVEL_ORDER_ERROR,
    payload: err,
  };
};

const getTravelOrderListStart = () => {
  return {
    type: GET_TRAVEL_ORDER_LIST_START,
  };
};
const getTravelOrderListSuccessfully = (data) => {
  return {
    type: GET_TRAVEL_ORDER_LIST,
    payload: data,
  };
};
const getTravelOrderListUnsuccessfully = (err) => {
  return {
    type: GET_TRAVEL_ORDER_LIST_ERROR,
    payload: err,
  };
};

export const createTravelOrder = (travelOrder, callback) => {
  return (dispatch) => {
    dispatch(addTravelOrderStart());
    return apiService
      .post(travelOrderAddPath(), travelOrder)
      .then((response) => {
        dispatch(addTravelOrderSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateTravelOrder.saveSuccessMessage,
          travelOrder
        );
        callback();
      })
      .catch((err) => {
        dispatch(addTravelOrderUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateTravelOrder = (travelOrder, callback) => {
  return (dispatch) => {
    dispatch(updateTravelOrderStart());
    return apiService
      .post(travelOrderUpdatePath(), travelOrder)
      .then((response) => {
        dispatch(updateTravelOrderSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateTravelOrder.updateSuccessMessage,
          travelOrder
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateTravelOrderUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findAllTravelOrderPageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getTravelOrderPageableListStart());
    return apiService
      .get(travelOrderFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getTravelOrderPageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getTravelOrderListPageableUnsuccessfully(err));
      });
  };
};

export const findTravelOrderById = (id) => {
  return (dispatch) => {
    dispatch(getTravelOrderStart());
    return apiService
      .get(travelOrderFindByIdPath(id))
      .then((response) => {
        dispatch(getTravelOrderSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getTravelOrderUnsuccessfully(err));
      });
  };
};

export const deleteTravelOrder = (id) => {
  return (dispatch) => {
    dispatch(deleteTravelOrderStart());
    return apiService
      .delete(travelOrderDeletePath(id))
      .then(() => {
        dispatch(deleteTravelOrderSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateTravelOrder.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteTravelOrderUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorTravelOrder = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllTravelOrder = () => {
  return (dispatch) => {
    dispatch(getTravelOrderListStart());
    return apiService
      .get(travelOrderFindAllPath())
      .then((response) => {
        dispatch(getTravelOrderListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getTravelOrderListUnsuccessfully(err));
      });
  };
};

export const download = (id) => {
  return (dispatch) => {
    return apiService
      .getFromFile(travelOrderDownloadPath(id))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'travel-order.pdf';
        
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch && fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        handleServerErrorMessage("Error downloading file");
      });
  };
};